import VideoModal from './VideoModal';

export { type VideoModalProps, type VideoModalRef } from './VideoModal';
export default VideoModal;
